Vue.component('vq-radio', {
  delimiters: ['[[', ']]'],
  inject: ['$validator'],
  props: {
    label: String,
    labelClasses: String,
    model: Object,
    name: String,
    options: Array,
    optional: {
      type: Boolean,
      default: false,
    },
    validate: {
      type: String,
      default: 'required'
    },
    validateName: String,
    validation: {
      type: Boolean,
      default: true
    },
  },
  computed: {
    sync_model: {
      get() {
        return this.model.value
      },
      set(val) {
        this.$emit('update:model', { value: val })
      }
    },
    sync_validate() {
      if (this.optional && this.validate == 'required') {
        return '';
      } else if (!this.optional && this.validate != 'required') {
        return 'required|' + this.validate;
      } else {
        return this.validate;
      }
    },
    sync_validateName() {
      if (!this.validateName && this.label) {
        return this.label;
      } else {
        return this.validateName;
      }
    }
  },
  watch: {
    model: {
      immediate: true,
      handler() {
        if (!this.model.hasOwnProperty('value')) {
          this.$emit('update:model', { value: '' })
        }
      }
    }
  },
  methods: {
    classesValidation() {
      return {
        'is-valid': (!this.errors.has(this.name) && this.model.value !== '') || (!this.errors.has(this.name) && typeof this.model.value === 'boolean'),
        'is-error': this.errors.has(this.name)
      }
    },
  },
  mounted() {
    if (!this.model.hasOwnProperty('value')) {
      this.$emit('update:model', { value: '' })
    }
  },
  template: `<div class="form-control" :class="[classesValidation(), {'has-validation': validation}]">
	<div class="wrapper">
		<span class="is-optional" v-if="optional">optionnel</span>
		<div class="input-group">
			<div class="item" v-for="option in options">
				<input class="radio" v-model="sync_model" type="radio" :name="name" :id="name+'-'+option.value"
					:value="option.value" v-validate="sync_validate" :data-vv-as="sync_validateName">
				<label :for="name+'-'+option.value">[[option.label]]</label>
			</div>
		</div>
	</div>
</div>`
})